import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='working-with-an-advisor-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={
      <>
        Our financial advisors are here to <WidowBlock>guide you</WidowBlock>
      </>
    }
    // column content
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          With Northwestern Mutual, you&#39;ll get a financial partner who really hears you&#8212;who listens to your concerns and guides you through them, so you know you&#39;ll make the best financial choices. Working together, you and your financial advisor will design a flexible plan tailored to your life and your needs. And as your priorities change, your advisor will be there every step of the way, adjusting your plan to keep your goals <WidowBlock>on track.</WidowBlock>
        </Typography>
        <Link
          id='working-with-an-advisor-intro-section-get-started-link'
          variant='buttonLinkPrimary'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Get started with a financial advisor'>
          Get started
        </Link>
      </>
    )}
  />
);
